<template>
  <div class="adminAccommodation">
    <h1>Ubytování</h1>

    <tabloid name="accommodation" :columns="columns" :data="accommodation">
      <template v-slot:isReservedByAdmin="{ row }">
        <checkInputer :paths="['accommodation', row.id, 'isReservedByAdmin']" />
      </template>
    </tabloid>

    <img id="map_background" src="map.jpg" alt="mapa" />
    <mapSchema />
  </div>
</template>
  
<script>
import { mapState } from "vuex";
import { _ } from "../../extend";
import mapSchema from "./parts/map_schema";
import tabloid from "../../components/tabloid";
import checkInputer from "../../components/inputer-check";

export default {
  name: "accommodation",
  components: {
    mapSchema,
    tabloid,
    checkInputer,
  },
  data: () => ({
    columns: {
      id: { title: "Označení ubytování" },
      description: { title: "Popis" },
      amount: { title: "Počet míst" },
      price: { title: "Cena" },
      isReservedByAdmin: { title: "Rezervováno organizátory" },
      actions: { title: " " },
    }
  }),
  computed: {
    ...mapState(["accommodation", "outpost", "outposts"]),
  },
  methods: {
  }
};
</script>
  
<style lang="sass">
@import ../../sass/_constants
@import ../../sass/_components

.adminAccommodation
  display: grid
  margin:
    right: auto
    left: auto
  height: 100%
  width: $w-content
  align-items: center
  justify-items: center

  grid-template-areas: "label link" "table table" "map map"
  grid-row-gap: 5px
  .data
    font-weight: bold

  h1
    grid-area: label
    justify-self: start
  .tabloid
    grid-area: table
  #map_background
    grid-area: map
  #map_schema
    grid-area: map
    g *
      cursor: pointer;
</style>